
import React from 'react';
import { COLORS, NEUTRAL_TEXT0, PRIMARY0 } from '../../config/designSystem/Colors';
import { EvolunoCheck } from '../../assets/images/Icons/Check/EvolunoCheck';
import { ParagraphMRegular } from '../../config/designSystem/typography';
import { TouchableOpacity, View } from 'react-native';

interface ItemSelectorProps {
    label: string,
    selected: boolean,
    onSelect: () => void;
    width?: number;
}

export const ItemSelectorList = ({ label, selected, onSelect, width }: ItemSelectorProps) => {
  const BACKGROUND_COLOR= selected? PRIMARY0:NEUTRAL_TEXT0;
  return (
    <TouchableOpacity style={[{
      backgroundColor: BACKGROUND_COLOR,
      borderWidth: 1,
      borderColor: COLORS.brand[500],
      borderRadius: 5,
      marginVertical: 10,
      padding: 15,
      flexDirection: 'row',
      justifyContent: 'space-between',
      alignItems:'center',

    }, !!width && {width}]}
    onPress={onSelect}>
      <View>
        <ParagraphMRegular>
          {label}
        </ParagraphMRegular>
      </View>
      {selected && (<EvolunoCheck size={20} color={COLORS.brand[500]}/>)}
    </TouchableOpacity>
  );
};



